(function () {
    var nav = document.querySelector('.cal-toolbar');
    if (!nav) return;
    var input = document.getElementById('yearNavInput');
    if (!input) return;
    var minYear = parseInt(nav.dataset.minYear, 10);
    var maxYear = parseInt(nav.dataset.maxYear, 10);
    var baseUrl = nav.dataset.baseUrl;
    var urlSuffix = nav.dataset.urlSuffix || '';
    var currentVal = parseInt(input.value, 10);

    function go(year) {
        if (isNaN(year)) { input.value = currentVal; return; }
        var clamped = Math.max(minYear, Math.min(maxYear, year));
        if (clamped !== currentVal) {
            window.location = baseUrl + clamped + urlSuffix;
        } else {
            input.value = currentVal;
        }
    }

    input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            go(parseInt(input.value, 10));
        }
    });

    input.addEventListener('blur', function () {
        var v = parseInt(input.value, 10);
        if (!isNaN(v) && v !== currentVal) {
            go(v);
        } else {
            input.value = currentVal;
        }
    });
})();
